const footerItemsList = [
	{ text: "Instagram", href: "https://www.instagram.com/momokuofficial/" },
	{ text: "Twitter", href: "https://twitter.com/momokuofficial" },
	{ text: "Discord", href: "https://discord.com/invite/zqmbX52VUX" },
];

export default footerItemsList;
